import HttpClientToken from '../../services/HttpClientToken';

import { UnidadProps, defaultUnidad } from '../../interfaces/catalogos/UnidadInterface';

export const Unidades = () => {

    return new Promise<UnidadProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Unidad/', token)
            .then( ({ data } : { data : UnidadProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerUnidad = () => {

    return new Promise<UnidadProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Unidad/ObtenerUnidades', token)
            .then( ({ data } : { data : UnidadProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarUnidad = ( params: UnidadProps ) => {

    return new Promise<UnidadProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Unidad/Actualizar', params, token)
            .then( ({ data } : { data : UnidadProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultUnidad } );
            });

        }

    });

}

export const AgregarUnidad = ( params: UnidadProps ) => {

    return new Promise<UnidadProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Unidad/Agregar', params, token)
            .then( ({ data } : { data : UnidadProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultUnidad } );
            });

        }

    });

}
